import angular from 'angular'

import ggsAttr from '../ggs-attr'
import ggsUtils from '../utils'
import ggsIcons from '../ggs-icons'
import ggsSpinner from '../ggs-spinner'
import ggsHighlighter from '../ggs-highlighter'
import ggsRecalcOnevent from '../ggs-recalc-onevent'

import ggsGalleryUser from '../gallery-user'
import ggsGallerySharing from '../gallery-sharing'
import ggsGalleryVoteFrame from '../gallery-vote-frame'
import ggsGalleryVoteCount from '../gallery-vote-count'
import ggsGalleryBranding from '../gallery-branding'
import ggsGallerySlider from './gallery-slider'

export default angular
  .module('ggs.gallery-modal', [
    ggsAttr,
    ggsUtils,
    ggsIcons,
    ggsSpinner,
    ggsHighlighter,
    ggsRecalcOnevent,

    ggsGalleryUser,
    ggsGallerySharing,
    ggsGalleryVoteFrame,
    ggsGalleryVoteCount,
    ggsGalleryBranding,

    ggsGallerySlider
  ])
  .name
